import React, { memo } from "react";
import { Link } from "react-router-dom";

export default memo(function DonorList({ queryResult, entity }) {
  const donorList = queryResult.map((donor) => {
    return (
      <>
        <ul className="list-group">
          <li className="list-group-item d-flex bg-info-subtle" key={donor.id}>
            <section className="px-2 fw-bold">
              <Link className="" to={`/donordetails/${donor.donorId}`}>
                {" "}
                {donor.fullName}
              </Link>
            </section>
            <section className="px-2">{donor.pan}</section>
          </li>
        </ul>
        {/* <ul
          className="list-group-item d-flex list-group-item-info"
          key={entity === "donor" ? donor.donorId : donor.userId}
        >
          {entity === "donor" ? (
            <>
              <li
                className="list-group-item btn-group align-self-center pe-1"
                role="group"
              >
                <Link className="" to={`/donordetails/${donor.donorId}`}>
                  {" "}
                  {donor.fullName}
                </Link>
              </li>{" "}
              <li
                className="list-group-item btn-group align-self-center ps-1"
                role="group"
              >
                {donor.pan}
              </li>
            </>
          ) : (
            <>
              <section
                className="btn-group align-self-center pr-1"
                role="group"
              >
                <Link className="" to={`/userdetails/${donor.userId}`}>
                  {" "}
                  {donor.name}
                </Link>
              </section>{" "}
              <section
                className="btn-group align-self-center pl-1"
                role="group"
              >
                {donor.email}
              </section>
            </>
          )}
        </ul> */}
      </>
    );
  });
  return <div>{donorList}</div>;
});
